import React, { Component } from 'react';
// import imageBackground from '../../../containers/img/4GMobile_ico.png'
import './ExpireKeyErr.css';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
class ExpireKeyErr extends Component {

    componentDidMount() {
        // if (document.getElementById("wrapper") !== undefined) {
        //     document.getElementById("wrapper").className += "bg";
        // }




    }
    // e04f5f
    render() {
    const { t } = this.props;

    let message = null;
    let languageText = "";

    if (this.props.location.state !== undefined) {

        if (this.props.location.state.hasOwnProperty("locale")) {
            let locale = this.props.location.state.locale;
            languageText = locale.split("=");
            this.props.i18n.changeLanguage(languageText[1]);
        }

        if (this.props.location.state.hasOwnProperty("message")) {
            message = this.props.location.state.message;
        }
    }

    return (
        <div className="">
            <div className="NotFound">
                <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
                    <div className="page-error-content">
                        <div className="error-code mb-4 animated zoomInDown"></div>

                        <h2 className="text-center fw-regular title bounceIn animation-delay-10 animated">
                            {message ? message : t('alerts.errTokenVerify')}
                        </h2>

                        <button
                            onClick={() => this.props.history.push("/")}
                            style={{
                                backgroundColor: "#bf2349",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                padding: "10px 20px",
                                marginTop: "20px",
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, transform 0.1s ease",
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#a71c3e"}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#bf2349"}
                            onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.98)"}
                            onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
                        >
                            Volver al inicio de sesión
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
}

export default withRouter(withTranslation()(ExpireKeyErr));
